import { render, staticRenderFns } from "./data-table-widget.vue?vue&type=template&id=28116d2b&scoped=true&"
import script from "./data-table-widget.vue?vue&type=script&lang=js&"
export * from "./data-table-widget.vue?vue&type=script&lang=js&"
import style0 from "./data-table-widget.vue?vue&type=style&index=0&id=28116d2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28116d2b",
  null
  
)

export default component.exports